import React from 'react';
import { Icon, Button ,Spin, Row, Col, Badge } from 'antd';

export default ()=>{
    return (
        <div className='col-md-12 flex-center panel'>
            <div className="loading-spinner flex-center" aria-label="Loading, please wait...">
                <div className="svspin-con">
                   <Spin size="large" />
                </div>
            </div>
        </div>
    )
}